module.exports = __webpack_public_path__ + "img/1557614069556518914.20b9e505.png";